<template>
  <div class="px-6 pb-7">
    <div class="Kanit my-5" style="font-weight: 500">ข้อมูลเจ้าของร้าน</div>
    <ValidationObserver ref="observer">
      <ValidationProvider name="ชื่อ" :rules="'required'" v-slot="{ errors }">
        <div>ชื่อ<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          :error-messages="errors"
          v-model="input.firstName"
        ></custom-input>
      </ValidationProvider>
      <ValidationProvider
        name="นามสกุล"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <div>นามสกุล<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          :error-messages="errors"
          v-model="input.lastName"
        ></custom-input>
      </ValidationProvider>
      <ValidationProvider
        name="เลขบัตรประจำตัวประชาชน"
        :rules="'required|thai_idcard'"
        v-slot="{ errors }"
      >
        <div>เลขบัตรประจำตัวประชาชน<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          :maxlength="13"
          :type="'number'"
          :error-messages="errors"
          v-model="input.identityNumber"
        ></custom-input>
      </ValidationProvider>
      <div>เบอร์โทรศัพท์มือถือ<span class="red--text">*</span></div>
      <custom-input
        outlined
        dense
        :maxlength="10"
        :type="'number'"
        :error-messages="errors"
        v-model="input.username"
        readonly
      ></custom-input>
      <ValidationProvider
        name="อีเมล"
        :rules="'required|email'"
        v-slot="{ errors }"
      >
        <div>อีเมล<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          :error-messages="errors"
          v-model="input.email"
        ></custom-input>
      </ValidationProvider>
      <div class="Kanit mb-5" style="font-weight: 500">ข้อมูลร้านค้า</div>
      <ValidationProvider
        name="ชื่อร้านค้า"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <div>ชื่อร้านค้า<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          :error-messages="errors"
          v-model="input.shopName"
        ></custom-input>
      </ValidationProvider>
      <ValidationProvider
        name="ที่อยู่ร้านค้า"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <div>ที่อยู่ร้านค้า<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          :error-messages="errors"
          v-model="input.shopAddress"
        ></custom-input>
      </ValidationProvider>
      <ValidationProvider
        name="เบอร์โทรร้านค้า"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <div>เบอร์โทรร้านค้า<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          :error-messages="errors"
          v-model="input.shopPhone"
        ></custom-input>
      </ValidationProvider>
      <ValidationProvider
        name="รหัสไปรษณีย์"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <div>รหัสไปรษณีย์<span class="red--text">*</span></div>
        <ThaiAddressInput
          :inputtype="'number'"
          @select="onSelectAddress"
          v-model="input.shopPostcode"
          :type="'zipcode'"
          :errorMessages="errors"
          :texttype="'number'"
        ></ThaiAddressInput>
      </ValidationProvider>
      <ValidationProvider name="เขต" :rules="'required'" v-slot="{ errors }">
        <div>เขต<span class="red--text">*</span></div>
        <ThaiAddressInput
          :inputtype="'text'"
          @select="onSelectAddress"
          v-model="input.shopDistrict"
          :type="'amphoe'"
          :errorMessages="errors"
          :texttype="'text'"
        ></ThaiAddressInput>
      </ValidationProvider>
      <ValidationProvider name="แขวง" :rules="'required'" v-slot="{ errors }">
        <div>แขวง<span class="red--text">*</span></div>
        <ThaiAddressInput
          :inputtype="'text'"
          @select="onSelectAddress"
          v-model="input.shopSubDistrict"
          :type="'district'"
          :errorMessages="errors"
          :texttype="'text'"
        ></ThaiAddressInput>
      </ValidationProvider>
      <ValidationProvider
        name="จังหวัด"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <div>จังหวัด<span class="red--text">*</span></div>
        <ThaiAddressInput
          :inputtype="'text'"
          @select="onSelectAddress"
          v-model="input.shopProvince"
          :type="'province'"
          :errorMessages="errors"
          :texttype="'text'"
        ></ThaiAddressInput>
      </ValidationProvider>
      <div class="mb-5">
        <div class="Kanit" style="font-weight: 500">ข้อมูลเลขบัญชี</div>
        <div class="Kanit" style="color:red;font-size:12px">
          *เพื่อที่ใช้ในการรับผลตอบแทน
        </div>
      </div>
      <ValidationProvider
        name="เลขบัญชีธนาคาร"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <div>เลขบัญชีธนาคาร<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          type="number"
          :error-messages="errors"
          v-model="input.bankAccountNumber"
        ></custom-input>
      </ValidationProvider>
      <ValidationProvider
        name="ชื่อธนาคาร"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <div>ชื่อธนาคาร<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          :error-messages="errors"
          v-model="input.bank"
        ></custom-input>
      </ValidationProvider>
      <ValidationProvider name="สาขา" :rules="'required'" v-slot="{ errors }">
        <div>สาขา<span class="red--text">*</span></div>
        <custom-input
          outlined
          dense
          :error-messages="errors"
          v-model="input.branch"
        ></custom-input>
      </ValidationProvider>
      <div class="text-center">
        <v-btn :loading="saveloading" @click="next" color="primary">
          ลงทะเบียน
        </v-btn>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import ThaiAddressInput from "@/components/ThaiAddressInput.vue";
import axios from "axios";
export default {
  components: { ThaiAddressInput },
  data() {
    return {
      saveloading: false,
      confirm_password: "",
    };
  },
  computed: {
    input() {
      return this.$store.state.input;
    },
  },
  created() {
    this.$store.state.headertext = "REGISTER";
  },
  methods: {
    onSelectAddress(address) {
      this.input.shopDistrict = address.amphoe;
      this.input.shopProvince = address.province;
      this.input.shopSubDistrict = address.district;
      this.input.shopPostcode = address.zipcode;
    },
    // yasale/register
    async next() {
      if (await this.$refs.observer.validate()) {
        this.saveloading = true;
        axios
          .get(this.serverUrl + "yasale/duplicate-identitynumber", {
            headers: { AUTHORIZATION: "Bearer xxxx xxxx" },
            params: {
              identityNumber: this.input.identityNumber,
            },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data.responsecode == 200) {
              this.saveData();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
          });
      }
    },
    saveData() {
      this.saveloading = true;
      var data = {
        username: this.input.username,
        userid: this.userid,
        pageid: this.query.pageid,
        identityNumber: this.input.identityNumber,
        password: this.input.password,
        firstName: this.input.firstName,
        lastName: this.input.lastName,
        phoneNumber: this.input.username,
        email: this.input.email,
        shopName: this.input.shopName, // ชื่อร้านค้า
        shopAddress: this.input.shopAddress, // ที่อยู่ร้านค้า
        shopPhone: this.input.shopPhone,
        shopProvince: this.input.shopProvince, // จังหวัดที่อยู่ร้านค้า
        shopDistrict: this.input.shopDistrict, // จังหวัดที่อยู่ร้านค้า
        shopSubDistrict: this.input.shopSubDistrict, // จังหวัดที่อยู่ร้านค้า
        shopPostcode: this.input.shopPostcode, // รหัสไปรษณีย์ที่อยู่ร้านค้า
        bankAccountNumber: this.input.bankAccountNumber, // เลขบัชีธนาคาร
        bank: this.input.bank, // ชื่อธนาคาร
        branch: this.input.branch, // สาขาธนาคาร
      };

      axios
        .post(this.serverUrl + "yasale/register", data, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
        })
        .then(async (response) => {
          this.saveloading = false;
          if (response.data.responsecode == 200) {
            this.$store.state.member = response.data.data[0];
            this.$emit("nextstep");
          } else {
            await this.$swal.fire({
              text: response.data.reason,
            });
            if (response.data.responsecode == 400) {
              this.$liff.closeWindow();
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
